// src/client/game/core/enemy/EnemyAgent.ts
import { Snake } from "../Snake";
import type { EnemyController } from "./EnemyController";
import type { Weapon } from "./weapons/Weapon";

export type EnemyId = string;

/**
 * Thin wrapper around a Snake that gives it behavior (controller) and optional weapon.
 * Not wired into gameplay yet; this is scaffolding for future refactors.
 */
export class EnemyAgent {
  constructor(
    public readonly id: EnemyId,
    public readonly snake: Snake,
    public controller: EnemyController,
    public weapon: Weapon | null = null
  ) {}
}
